import { Badge, Box, Flex } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';

export enum StatusTypes {
  Active = 'active',
  Completed = 'completed',
}

interface StatusBadgeProps {
  status: StatusTypes;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  let badgeColor = '';
  let badgeText = '';
  let circleColor = '';
  let badgeTextColor = '';

  switch (status?.toLowerCase()) {
    case StatusTypes.Completed:
      badgeColor = 'brand.gray';
      badgeText = 'Completed';
      badgeTextColor = 'brand.black';
      circleColor = 'gray';
      break;
    case StatusTypes.Active:
    default:
      badgeColor = 'rgba(36, 161, 72, 0.2)';
      badgeText = 'Active';
      circleColor = Colors.ForestGreen900;
      badgeTextColor = 'brand.black';
      break;
  }

  return (
    <Badge
      sx={{
        backgroundColor: badgeColor,
        color: badgeTextColor,
        letterSpacing: '0.06em',
        padding: '4px 12px 4px 12px',
        borderRadius: '4px',
      }}
    >
      <Flex align="center">
        <Box w="8px" h="8px" bg={circleColor} borderRadius="50%" marginRight="8px" />
        {badgeText}
      </Flex>
    </Badge>
  );
};

export default StatusBadge;
